import { styled } from '@mui/material/styles';
import { Box, Button, TextField } from '@mui/material';

export const Container = styled(Box)(({ theme }) => ({
  maxWidth: 600,
  margin: '40px auto',
  background: '#fff',
  borderRadius: 8,
  boxShadow: '0 2px 8px rgba(0,0,0,0.07)',
  padding: theme.spacing(4),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

export const Header = styled('div')(({ theme }) => ({
  fontWeight: 700,
  marginBottom: theme.spacing(1),
  fontSize: 24,
}));

export const Subheader = styled('div')(({ theme }) => ({
  color: '#444',
  marginBottom: theme.spacing(2),
}));

export const Form = styled('form')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

export const Row = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
}));

export const StyledTextField = styled(TextField)(({ theme }) => ({
  flex: 1,
}));

export const CheckboxRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  marginTop: theme.spacing(1),
}));

export const CaptchaRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  marginTop: theme.spacing(1),
}));

export const CaptchaBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
}));

export const CaptchaPlaceholder = styled(Box)(({ theme }) => ({
  width: 120,
  height: 40,
  background: '#f0f0f0',
  borderRadius: 4,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: '#888',
  fontSize: 12,
  border: '1px solid #ddd',
}));

export const SubmitBtn = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(2),
  background: '#FF0872',
  color: '#fff',
  fontWeight: 700,
  '&:hover': {
    background: '#CC005A',
  },
})); 